import { lazy } from 'react';
import { Package } from 'lucide-react';
import { defineFrontendModule } from '../../core/modules/types';
import { registerInventarWidgets } from './widgets';

export default defineFrontendModule({
  id: 'inventar',
  name: 'Inventar',

  // URL kept from 1.x (bookmarks)
  routes: [
    { path: 'technik/inventory', menuKey: 'technik.inventory', element: lazy(() => import('./pages/Inventory')) },
  ],

  nav: [{ menuKey: 'technik.inventory', path: '/technik/inventory', defaultIcon: Package }],

  registerWidgets: registerInventarWidgets,

  // Own tab in Administration › Settings (categories, prefixes, locations)
  settingsPanels: {
    inventory: lazy(() => import('./settings/InventorySettings')),
  },
});
